import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "relative click-to-show-hide-code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }, [
      _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Vimeo Ratio (21x9)")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "clickToSeeCodeBtn inline-block text-black dark:text-white font-semibold",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCode && _ctx.toggleCode(...args)))
      }, _toDisplayString(_ctx.showCode ? "Click to Hide Code:" : "Click to See Code:"), 1),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "absolute text-lg ltr:right-[20px] rtl:left-[20px] top-[20px] transition-all text-primary-500 copy-btn w-[35px] h-[35px] inline-block border border-primary-500 bg-white rounded-sm dark:bg-[#0c1427]",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args))),
          type: "button"
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "ri-file-copy-line" }, null, -1)
        ])),
        _cache[3] || (_cache[3] = _createElementVNode("pre", { class: "line-numbers !mt-[15px] !py-0 !px-[20px] md:!px-[25px] mb-0" }, [
          _createTextVNode(""),
          _createElementVNode("code", {
            class: "language-markup",
            id: "copyCodes"
          }, "\n<iframe class=\"w-full aspect-[21/9]\" src=\"https://player.vimeo.com/video/45830194?h=2c5541d8bc&color=ffffff&title=0&byline=0&portrait=0&badge=0\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" allowfullscreen></iframe>\n"),
          _createTextVNode("\n")
        ], -1))
      ], 512), [
        [_vShow, _ctx.showCode]
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mt-[15px] md:mt-[20px]" }, null, -1)),
      _cache[5] || (_cache[5] = _createElementVNode("iframe", {
        class: "w-full aspect-[21/9]",
        src: "https://player.vimeo.com/video/45830194?h=2c5541d8bc&color=ffffff&title=0&byline=0&portrait=0&badge=0",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        referrerpolicy: "strict-origin-when-cross-origin",
        allowfullscreen: ""
      }, null, -1))
    ])
  ]))
}